import { ListItemIcon, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileLines, faReceipt } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    menuPaper: {
        minWidth: "14rem",
        borderRadius: ".75rem",
    },
    menuItem: {
        "&.MuiMenuItem-root": {
            minHeight: "auto",
            paddingTop: ".75rem",
            paddingBottom: ".75rem",
        },
    },
    itemIcon: {
        minWidth: "2rem",
        color: theme.palette.tailwind.slate[500],
    },
}))

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onPackingSlip: () => void
    onReceipt: () => void
}>

export function OrderDocumentsMenu({ anchorEl, onClose, onPackingSlip, onReceipt }: Props) {
    const { classes } = useStyles()

    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{ paper: { className: classes.menuPaper } }}
        >
            <MenuItem className={classes.menuItem} onClick={runAndClose(onPackingSlip)}>
                <ListItemIcon className={classes.itemIcon}>
                    <FontAwesomeIcon icon={faFileLines} />
                </ListItemIcon>
                <LocalizedStrict id="meeting-service-table-production-slip-button">
                    <span>Packing slip</span>
                </LocalizedStrict>
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={runAndClose(onReceipt)}>
                <ListItemIcon className={classes.itemIcon}>
                    <FontAwesomeIcon icon={faReceipt} />
                </ListItemIcon>
                <LocalizedStrict id="user-home-canteen-upcoming-orders-receipt-item">
                    <span>Receipt</span>
                </LocalizedStrict>
            </MenuItem>
        </Menu>
    )
}
